import React from 'react';
import { Button } from 'rsuite';
import styles from './EditBaseTable.module.scss';
import { BigNumbersArea, FiltersArea, TableActionArea, MainContainer } from '../../components';
import { EditTable } from './components/EditTable';
import {
  HeaderEditBaseTable,
  ModalCompetition,
  ModalCustosGeraisTabelaBase,
  ModalCustosProduto,
  ModalDiscriminationTable,
  ModalEditConfirmation,
  ModalPriceAnalysis,
  ModalSimulationResult,
} from './components';
import { useEditBaseTableList } from './hooks/useEditBaseTableList';
import { useEditBaseTableStore } from './EditBaseTable.store';
import { useHeaderUpdateTimeView } from './hooks/useHeaderUpdateTimeView';
import { useSaveCustosProduto } from './hooks/useSaveCustosProduto';
import { usePriceApply } from './hooks/usePriceApply';
import DownloadIcon from '../../../../../assets/icons/icon_download_gray600.svg';
import { useCustosGeraisTabela } from './hooks/useCustosGeraisTabela';
import * as utils from '../../utils';
import { FilterNames } from '../../types';
import { useTabelaBase } from '../CreateComercialTable/hooks/useTabelaBase';
import { useBaseTableBigNumbers } from './hooks/useBaseTableBigNumbers';

const MemoModalCustosGeraisTabelaBase = React.memo(ModalCustosGeraisTabelaBase);

export const EditBaseTable = () => {
  useTabelaBase(); // chama a lista da tabela base para obter o idTabelaBase

  const {
    openModalEditOtherCosts,
    productItemData,
    openModalPriceAnalysis,
    productItemSelectedList,
    openModalEditGeneralCosts,
    openModalEditConfirmation,
    custosProdutoBody,
    priceAnalysisTableData,
    selectAllTable,
    editBaseTableFiltersBody,
    editBaseTableBigNumbersData,
    updateBaseTableBigNumbers,
    setEditBaseTableState,
    setOpenModalEditOtherCosts,
    setOpenModalEditGeneralCosts,
  } = useEditBaseTableStore();

  const {
    tableData,
    editBaseTableParams,
    handleChangeEditBaseTableListPage,
    handleChangeEditBaseTableListLength,
    handleBlurCustoFabricacao,
    handleBlurPrecoMedio,
    handleBlurNovoPrecoTabela,
    setEditBaseTableParams,
  } = useEditBaseTableList();

  const { updateData } = useHeaderUpdateTimeView();

  const { handleSaveCustoProduto } = useSaveCustosProduto();
  const { handleConfirmPriceApply, handleConfirmPriceApplyAll } = usePriceApply();
  const { handleGetCustosGeraisTabelaData, custosGeraisTabelaData } = useCustosGeraisTabela();
  const { handleGetBaseTableBigNumbers } = useBaseTableBigNumbers();

  const handleOpenModalCustoGerais = () => {
    handleGetCustosGeraisTabelaData();
    setOpenModalEditGeneralCosts(true, null);
  };

  const handleChangeCheckboxAddSelectedProductItems = (product, checked) => {
    const addProduct = checked ? [...productItemSelectedList, product] : productItemSelectedList?.filter(item => item.id !== product.id);

    const productIds = addProduct?.map(item => item.id);

    setEditBaseTableState('productItemSelectedList', addProduct);
    setEditBaseTableState('priceApplyList', productIds);
    setEditBaseTableState('selectAllTable', false);
  };

  const handleClickSelectAllProducts = (all: boolean) => {
    setEditBaseTableState('productItemSelectedList', all ? tableData?.data?.content : []);
    setEditBaseTableState('selectAllTable', all);
  };

  const handleChangeCustosProduto = (objType: string, name: string, value: number) => {
    const objData = {
      ...custosProdutoBody,
      [objType]: {
        ...custosProdutoBody[objType],
        [name]: value,
      },
    };
    setEditBaseTableState('custosProdutoBody', objData);
  };

  const handleOpenModalEditConfirmation = () => {
    setEditBaseTableState('openModalEditOtherCosts', false);
    setEditBaseTableState('openModalEditConfirmation', true);
  };

  const handlePriceApply = (all: boolean) => {
    handleGetBaseTableBigNumbers({});
    if (all) {
      handleConfirmPriceApplyAll();
    } else {
      handleConfirmPriceApply();
    }
  };

  const handleOnSelectFilter = (name: FilterNames, value: string[]) => {
    const objData = {
      ...editBaseTableFiltersBody,
      [utils.filterNamesLabel[name]]: value,
    };
    setEditBaseTableState('editBaseTableFiltersBody', objData);
  };

  const handleOnCleanFilter = (name: FilterNames) => {
    const objData = {
      ...editBaseTableFiltersBody,
      [utils.filterNamesLabel[name]]: [],
    };
    setEditBaseTableState('editBaseTableFiltersBody', objData);
    setEditBaseTableParams({
      // chama a lista da tabela
      ...editBaseTableParams,
      [utils.filterNamesLabel[name]]: [],
    });
    handleGetBaseTableBigNumbers(objData); // chama os big numbers
  };

  const handleClickCleanFilters = () => {
    const objData = {
      descricao: [],
      familia: [],
      tier: [],
    };
    setEditBaseTableState('editBaseTableFiltersBody', objData);
    setEditBaseTableParams({
      // chama a lista da tabela
      ...editBaseTableParams,
      descricao: objData.descricao,
      familia: objData.familia,
      tier: objData.tier,
    });
    handleGetBaseTableBigNumbers(objData); // chama os big numbers
  };

  const handleChangeTableByFilter = () => {
    const objData = {
      ...editBaseTableParams,
      descricao: editBaseTableFiltersBody.descricao,
      familia: editBaseTableFiltersBody.familia,
      tier: editBaseTableFiltersBody.tier,
    };
    setEditBaseTableParams(objData); // chama a lista da tabela
    handleGetBaseTableBigNumbers(objData); // chama os big numbers
  };

  const handleClickUpdateBigNumbers = () => {
    handleGetBaseTableBigNumbers(editBaseTableFiltersBody);
    setEditBaseTableState('updateBaseTableBigNumbers', false);
  };

  return (
    <MainContainer>
      <HeaderEditBaseTable updateData={updateData} onClickEdit={handleOpenModalCustoGerais} />
      <BigNumbersArea update={updateBaseTableBigNumbers} data={editBaseTableBigNumbersData} onClickUpdate={handleClickUpdateBigNumbers} />
      <FiltersArea
        onSelect={handleOnSelectFilter}
        onClean={handleOnCleanFilter}
        onClose={handleChangeTableByFilter}
        onClickCleanFilters={handleClickCleanFilters}
      />
      <TableActionArea
        data={tableData?.data}
        selectedItems={productItemSelectedList}
        selectAll={selectAllTable}
        onClickSelectAll={handleClickSelectAllProducts}
      >
        {/* <Button className={styles['btn-gray']}>
                    <img src={DownloadIcon} alt="" />
                </Button> */}
        <Button
          className={styles['btn-apply']}
          appearance="primary"
          disabled={!productItemSelectedList?.length}
          onClick={() => handlePriceApply(selectAllTable)}
        >
          Aplicar preço
        </Button>
      </TableActionArea>
      <EditTable
        data={tableData?.data}
        onChangeCheckbox={handleChangeCheckboxAddSelectedProductItems}
        onBlurCustoFabricacao={handleBlurCustoFabricacao}
        onBlurPrecoMedio={handleBlurPrecoMedio}
        onBlurNovoPrecoTabela={handleBlurNovoPrecoTabela}
        onChangePage={handleChangeEditBaseTableListPage}
        onChangeLength={handleChangeEditBaseTableListLength}
      />
      <ModalCustosProduto
        show={openModalEditOtherCosts}
        title="Custos do produto"
        subtitle="Defina os custos específicos dos produtos selecionados"
        confirmButton="Salvar"
        cancelButton="Fechar"
        data={productItemData}
        onCancel={() => setOpenModalEditOtherCosts(false, null)}
        onConfirm={handleOpenModalEditConfirmation}
        onChangeCustosProduto={handleChangeCustosProduto}
      />
      <MemoModalCustosGeraisTabelaBase
        show={openModalEditGeneralCosts}
        title="Custos gerais da tabela base"
        subtitle="Defina os custos gerais para a formação da tabela base de preços. Esses valores refletirão em todos os itens da tabela"
        isAlertMessage
        data={custosGeraisTabelaData?.data}
      />
      <ModalSimulationResult />
      <ModalCompetition />
      <ModalDiscriminationTable />
      <ModalPriceAnalysis
        className="base"
        show={openModalPriceAnalysis}
        isAlertMessage
        tableHeight={228}
        title="Análise preço médio vs preço de tabela"
        data={priceAnalysisTableData}
        onCancel={() => setEditBaseTableState('openModalPriceAnalysis', false)}
      />
      <ModalEditConfirmation
        show={openModalEditConfirmation}
        onCancel={() => setEditBaseTableState('openModalEditConfirmation', false)}
        onConfirm={handleSaveCustoProduto}
      />
    </MainContainer>
  );
};
